/* tutor-1 (C): LA CHISPA DEL TUTOR (la marca de la maqueta): circulo con degradado naranja y la chispa de lucide.

   ARCHIVO EN ASCII A PROPOSITO. `tam` 24 (respuesta y estado), 22 (cabecera) o 48 (arranque, con halo). */
import React from 'react';
import { Sparkles } from 'lucide-react';

const DEGRADADO = 'radial-gradient(circle at 35% 35%, #FFB27A, #F27A2E 55%, #B04E14)';

export default function Chispa({ tam = 24, late = false, halo = false, testid }) {
  const icono = tam >= 48 ? 22 : 13;
  return (
    <span
      aria-hidden="true"
      data-testid={testid}
      className={`shrink-0 rounded-full flex items-center justify-center text-[#160A02]${late ? ' motion-safe:animate-pulse' : ''}`}
      style={{
        width: tam, height: tam, background: DEGRADADO,
        boxShadow: halo ? '0 0 48px rgba(242,122,46,.28)' : '0 0 0 1px rgba(242,122,46,.25)',
      }}
    >
      <Sparkles style={{ width: icono, height: icono }} />
    </span>
  );
}
